import { AxiosResponse } from 'axios'

import {
  FollowItemProps,
  GetFollowedProps,
  UnfollowItemProps,
} from '@bonhams1793/bonhams-typescript'

import { createAuthenticatedAxiosClient } from '@nx/axios-client'
import { BonhamsCookies } from '@nx/global-types'

export function getFollowedByType<T>({
  userId,
  type,
  cookies,
  baseURL,
}: GetFollowedProps & { cookies?: BonhamsCookies; baseURL: string }): Promise<
  AxiosResponse<T, unknown>
> {
  const authenticatedAxiosClient = createAuthenticatedAxiosClient({
    accessTokenSSR: cookies?.bonhams_access || '',
    refreshTokenSSR: cookies?.bonhams_token || '',
    baseURL,
  })

  return authenticatedAxiosClient.get<T>(`/api/client/${userId}/${type}-likes/`)
}

export function followItem<T>({
  userId,
  itemId,
  type,
  cookies,
  baseURL,
}: FollowItemProps & { cookies?: BonhamsCookies; baseURL: string }): Promise<
  AxiosResponse<T, unknown>
> {
  const authenticatedAxiosClient = createAuthenticatedAxiosClient({
    accessTokenSSR: cookies?.bonhams_access || '',
    refreshTokenSSR: cookies?.bonhams_token || '',
    baseURL,
  })

  return authenticatedAxiosClient.post(
    `/api/client/${userId}/${type}-likes/`,
    { sKey: itemId },
    { headers: { 'Content-Type': 'application/json' } }
  )
}

export function unfollowItem<T>({
  userId,
  itemId,
  type,
  cookies,
  baseURL,
}: UnfollowItemProps & { cookies?: BonhamsCookies; baseURL: string }): Promise<
  AxiosResponse<T, unknown>
> {
  const authenticatedAxiosClient = createAuthenticatedAxiosClient({
    accessTokenSSR: cookies?.bonhams_access || '',
    refreshTokenSSR: cookies?.bonhams_token || '',
    baseURL,
  })

  return authenticatedAxiosClient.delete(
    `/api/client/${userId}/${type}-likes/`,
    {
      headers: { 'Content-Type': 'application/json' },
      data: { sKey: itemId },
    }
  )
}
